import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useTheme } from "../contexts/ThemeContext";
import { Search, User, Moon, Sun, Zap } from "lucide-react";

export const Header: React.FC = () => {
  const { isAuthenticated, loginWithRedirect, logout, user } = useAuth0();
  const { theme, setTheme } = useTheme();

  const themeIcons = {
    light: <Sun size={20} />,
    dark: <Moon size={20} />,
    neon: <Zap size={20} />
  };

  return (
    <header className="header">
      <div className="header-left">
        <h1 className="logo">🎬 AITube</h1>
      </div>
      
      <div className="header-center">
        <div className="search-container">
          <input 
            type="text" 
            placeholder="Szukaj filmów AI..." 
            className="search-input"
          />
          <button className="search-button">
            <Search size={20} />
          </button>
        </div>
      </div>

      <div className="header-right">
        <button 
          className="theme-toggle"
          onClick={() => {
            const themes: ("light" | "dark" | "neon")[] = ["light", "dark", "neon"];
            const currentIndex = themes.indexOf(theme);
            const nextTheme = themes[(currentIndex + 1) % themes.length];
            setTheme(nextTheme);
          }}
        >
          {themeIcons[theme]}
        </button>

        {isAuthenticated ? (
          <div className="user-menu">
            <img 
              src={user?.picture || "/default-avatar.png"} 
              alt="Avatar" 
              className="user-avatar"
            />
            <button onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}>
              Wyloguj
            </button>
          </div>
        ) : (
          <button 
            className="login-button" 
            onClick={() => loginWithRedirect()}
          >
            <User size={20} />
            Zaloguj
          </button>
        )}
      </div>
    </header>
  );
};
